import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CognitoService } from 'app/shared/services/cognito.service';

export const dashboardAccessGuard: CanActivateFn = async () => {
  const cognitoService = inject(CognitoService);
  const router = inject(Router);

  const isAuthenticated = await cognitoService.isAuthenticated();
  if (!isAuthenticated) {
    router.navigate(['auth']).then(() => {});
  }
  return isAuthenticated;
};
